export enum SiteDomain {
    USERAPP = 'userapp',
    ADMIN = 'admin',
    PARTNER = 'partner',
    SUPPORT = 'support',
}

const currentDomain: null | SiteDomain = ((domain) => {
    switch (domain) {
        case SiteDomain.ADMIN:
            return SiteDomain.ADMIN
        case SiteDomain.PARTNER:
            return SiteDomain.PARTNER
        case SiteDomain.SUPPORT:
            return SiteDomain.SUPPORT
        case SiteDomain.USERAPP:
            return SiteDomain.USERAPP
        default:
            return null
    }
})((window.location.pathname.match(/^\/+([^/]+)\//) || [])[1])

export const isUserappDomain = currentDomain === SiteDomain.USERAPP
export const isAdminDomain = currentDomain === SiteDomain.ADMIN
export const isPartnerDomain = currentDomain === SiteDomain.PARTNER
export const isSupportDomain = currentDomain === SiteDomain.SUPPORT

export const isLandingPage = (location: string) => location === '/dashboard'

export default currentDomain
